(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgProjectTeam', sgProjectTeam);

  function sgProjectTeam () {

    return {
      templateUrl: 'app-legacy/components/sg-project-team/sg-project-team.html',
      restrict: 'E',
      controller: 'sgProjectTeamCtrl'
    };
  };

})();
